import { render, staticRenderFns } from "./institution-card.vue?vue&type=template&id=2d6e8387&"
import script from "./institution-card.vue?vue&type=script&lang=js&"
export * from "./institution-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports